import React, { Component, Fragment } from "react";
import Functions from "../../../src/functions";
import CustomFunctions from "../../../modules/functions";

const PROCESSING_MESSAGE_DELAY_MS = 7000;

function usesTelekomThankYouClose() {
	const UserType = Functions["custom"]["getUserType"]();
	const landPageData = JSON.parse(sessionStorage.landPageData || "{}");
	const inListOfWhatuspCss =
		landPageData.contractInfoCarrier?.inListOfWhatuspCss;

	if (UserType === "PREPAID_FROG" || UserType === "PREPAID_WHATSUP") {
		return false;
	}
	if (UserType === "HYBRID_RESIDENTIAL_COST_CONTROL" && inListOfWhatuspCss) {
		return false;
	}
	if (
		(UserType === "POSTB" ||
			UserType === "POSTB_SPLIT" ||
			UserType === "POSTR") &&
		inListOfWhatuspCss
	) {
		return false;
	}
	return true;
}

function ThankYouCloseOrBackLink() {
	if (usesTelekomThankYouClose()) {
		return (
			<a
				href="/"
				className="cancel"
				aria-label="Κλείσιμο"></a>
		);
	}
	return (
		<a
			href="/"
			className="cancel">
			Επιστροφή
		</a>
	);
}

class ThankYou extends Component {
	state = {
		data: [],
		control: null,
		loaded: false,
		polling: 0,
		delay: 2000,
		isPrepaidServiceActivation: false,
		isServiceEligibleForActivation: true,
		isTypeOfPurchaseEligibleForActivation: true,
		hasChecksEnd: false,
		rogActivation: false,
		postPass: false,
		postActive: false,
		postDeactive: false,
	};

	constructor(props) {
		super(props);
		this.processingMessageInitStarted = false;
	}

	initProcessingMessageDelay = () => {
		const showProcessingMessage = () => {
			const $ = window.jQuery || window.$;
			if ($ && $.fn && $.fn.fadeIn) {
				$(".thank-hold h3.processingMessage")
					.delay(PROCESSING_MESSAGE_DELAY_MS)
					.fadeIn();
				return;
			}

			this.processingMessageTimeout = setTimeout(() => {
				document
					.querySelectorAll(".thank-hold h3.processingMessage")
					.forEach((el) => {
						el.style.display = "block";
					});
			}, PROCESSING_MESSAGE_DELAY_MS);
		};

		if (window.jQuery || window.$) {
			showProcessingMessage();
			return;
		}

		let attempts = 0;
		this.jqueryWaitInterval = setInterval(() => {
			attempts += 1;
			if (window.jQuery || window.$) {
				clearInterval(this.jqueryWaitInterval);
				showProcessingMessage();
			} else if (attempts >= 50) {
				clearInterval(this.jqueryWaitInterval);
				showProcessingMessage();
			}
		}, 100);
	};

	componentDidMount() {
		let UserType = Functions["custom"]["getUserType"]();
		this.setState({
			control: this.props.control,
			loaded: true,
			data: this.props.data,
			isPrepaidServiceActivation: false,
			isServiceEligibleForActivation: true,
			isTypeOfPurchaseEligibleForActivation: true,
			hasChecksEnd: false,
			rogActivation: false,
			postPass: false,
			postActive: false,
			postDeactive: false,
		});
		if (this.props.data[0].status.value !== 200) {
			this.setState({
				loaded: false,
			});
		} else {
			if (
				UserType === "POSTB" ||
				UserType === "POSTR" ||
				UserType === "POSTB_SPLIT"
			) {
				if (
					this.props.data[0].data.data.data &&
					this.props.data[0].data.data.data.activation === null &&
					this.props.data[0].data.data.data.deactivation === null &&
					this.props.data[0].data.data.data.id === "ROR"
				) {
					this.setState({
						rogActivation: true,
					});
				} else if (
					this.props.data[0].data.data.data &&
					this.props.data[0].data.data.data.activation === null &&
					this.props.data[0].data.data.data.deactivation === null
				) {
					this.setState({
						postPass: true,
					});
				} else if (
					this.props.data[0].data.data.data &&
					this.props.data[0].data.data.data.activation !== null
				) {
					this.setState({
						postActive: true,
					});
				} else if (
					this.props.data[0].data.data.data &&
					this.props.data[0].data.data.data.deactivate !== null
				) {
					this.setState({
						postDeactive: true,
					});
				}
			} else {
				if (
					this.props.data[0].data.data.data &&
					this.props.data[0].data.data.data.activation === null &&
					this.props.data[0].data.data.data.deactivation === null
				) {
					this.setState({
						isPrepaidServiceActivation: true,
					});
				}
				if (
					this.props.data[0].data.data.data &&
					this.props.data[0].data.data.data.activation !== null
				) {
					this.setState({
						postActive: true,
					});
				}
				if (
					this.props.data[0].data.data.data &&
					this.props.data[0].data.data.data.deactivate !== null
				) {
					this.setState({
						postDeactive: true,
					});
				}
				if (
					this.props.data[0].data.data.data
						.PREPAID_SERVICE_PROVISIONING_REQUEST !== null &&
					this.props.data[0].data.data.data.PREPAID_SERVICE_PROVISIONING_REQUEST
						.typeOfPurchaseeligibleForActivation === false
				) {
					this.setState({
						isTypeOfPurchaseEligibleForActivation: false,
					});
				}
				if (
					this.props.data[0].data.data.data
						.PREPAID_SERVICE_PROVISIONING_REQUEST !== null &&
					this.props.data[0].data.data.data.PREPAID_SERVICE_PROVISIONING_REQUEST
						.serviceEligibleForActivation === false
				) {
					this.setState({
						isServiceEligibleForActivation: false,
					});
				}
			}
			if (
				UserType === "HYBRID_BUSINESS_COST_CONTROL" &&
				sessionStorage.getItem("pt") === "BLNC"
			)
				return;

			this.interval = setInterval(this.fetchAPIData, this.state.delay);
		}
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (
			!prevState.loaded &&
			this.state.loaded &&
			!this.processingMessageInitStarted
		) {
			let UserType = Functions["custom"]["getUserType"]();
			if (
				!(
					UserType === "HYBRID_BUSINESS_COST_CONTROL" &&
					sessionStorage.getItem("pt") === "BLNC"
				)
			) {
				this.processingMessageInitStarted = true;
				this.initProcessingMessageDelay();
			}
		}

		if (prevState.delay !== this.state.delay) {
			clearInterval(this.interval);
			let UserType = Functions["custom"]["getUserType"]();
			if (
				UserType === "HYBRID_BUSINESS_COST_CONTROL" &&
				sessionStorage.getItem("pt") === "BLNC"
			)
				return;
			this.interval = setInterval(this.fetchAPIData, this.state.delay);
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval);
		clearInterval(this.jqueryWaitInterval);
		clearTimeout(this.processingMessageTimeout);
	}
	fetchAPIData = () => {
		let UserType = Functions["custom"]["getUserType"]();
		const numberOfLoops =
			UserType === "POSTB" || UserType === "POSTR" || UserType === "POSTB_SPLIT"
				? 4
				: 7;
		const nextPolling = this.state.polling + 1;

		this.setState({
			polling: nextPolling,
			numberOfLoops,
		});

		if (nextPolling <= numberOfLoops) {
			let UserType = Functions["custom"]["getUserType"]();
			let url =
				UserType === "PREPAID_FROG" ||
				UserType === "PREPAID_COSMOKARTA" ||
				UserType === "PREPAID_WHATSUP" ||
				UserType === "HYBRID_BUSINESS_COST_CONTROL" ||
				UserType === "HYBRID_RESIDENTIAL_COST_CONTROL"
					? CustomFunctions.restAPI("/service/getLastPrepaidOrderStatus")
					: CustomFunctions.restAPI("/service/getLastOrderStatus");

			fetch(url, { method: "POST" })
				.then((res) => res.json())
				.then((data) => {
					if (url.indexOf("/service/getLastPrepaidOrderStatus") !== -1) {
						if (!this.state.isTypeOfPurchaseEligibleForActivation) {
							let submitServicePurchaseDetailsResponse =
								this.state.data[0].data.data.data
									.PREPAID_SERVICE_PROVISIONING_REQUEST.purchaseDetails;
							if (
								submitServicePurchaseDetailsResponse.reasonOfIneligibility ===
								"NOT_ENOUGH_BALANCE"
							) {
								if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML =
										" καθώς δεν έχετε επαρκές χρηματικό υπόλοιπο";
								} else {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML =
										" καθώς δεν έχεις επαρκές χρηματικό υπόλοιπο";
								}
							} else if (
								submitServicePurchaseDetailsResponse.reasonOfIneligibility ===
								"REACHED_MAX_PROVISIONED"
							) {
								if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML = " καθώς έχετε ήδη αγοράσει 3 πακέτα";
								} else {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML = " καθώς έχεις ήδη αγοράσει 3 πακέτα";
								}
							} else if (
								submitServicePurchaseDetailsResponse.reasonOfIneligibility ===
								"ALREADY_ACTIVE"
							) {
								if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML =
										" καθώς ο τρόπος πληρωμής είναι ήδη επιλεγμένος";
								} else {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML =
										" καθώς ο τρόπος πληρωμής είναι ήδη επιλεγμένος";
								}
							} else if (
								submitServicePurchaseDetailsResponse.reasonOfIneligibility ===
								"SUB_ALREADY_IN_DOUBLE_OFFER"
							) {
								if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML =
										". Έχετε ήδη  την προσφορά και θα αποδοθεί στον επόμενο τιμολογιακό του κύκλο";
								} else {
									document.getElementsByClassName(
										"customClassFailureReason",
									)[0].innerHTML =
										". Έχετε ήδη  την προσφορά και θα αποδοθεί στον επόμενο τιμολογιακό του κύκλο";
								}
							}
							document.getElementsByClassName(
								"processingMessage",
							)[0].style.display = "block";
							setTimeout(() => {
								document.getElementsByClassName("loading")[0].style.display =
									"none";
								document.getElementsByClassName(
									"customClassThankYouDiv",
								)[0].style.display = "none";
								document.getElementsByClassName(
									"customClassUnsuccessfulPrepaidServiceActivation",
								)[0].style.display = "block";
							}, 2000);
							clearInterval(this.interval);
						} else {
							if (
								data.item.status === "PROVISIONED_FAILED" ||
								data.item.status === "PROVISIONING_NOT_EXISTS"
							) {
								if (!this.state.isPrepaidServiceActivation) {
									document.getElementsByClassName(
										"processingMessage",
									)[0].style.display = "block";
									setTimeout(() => {
										document.getElementsByClassName(
											"loading",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassThankYouDiv",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassUnsuccessfulActivation",
										)[0].style.display = "block";
									}, 2000);
								} else {
									if (data.item.responseCode === "NOT_ENOUGH_BALANCE") {
										if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML =
												" καθώς δεν έχετε επαρκές χρηματικό υπόλοιπο";
										} else {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML =
												" καθώς δεν έχεις επαρκές χρηματικό υπόλοιπο";
										}
									} else if (
										data.item.responseCode === "REACHED_MAX_PROVISIONED"
									) {
										if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML = " καθώς έχετε ήδη αγοράσει 3 πακέτα";
										} else {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML = " καθώς έχεις ήδη αγοράσει 3 πακέτα";
										}
									} else if (data.item.responseCode === "ALREADY_ACTIVE") {
										if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML =
												" καθώς ο τρόπος πληρωμής είναι ήδη επιλεγμένος";
										} else {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML =
												" καθώς ο τρόπος πληρωμής είναι ήδη επιλεγμένος";
										}
									} else if (
										data.item.responseCode === "SUB_ALREADY_IN_DOUBLE_OFFER"
									) {
										if (UserType === "HYBRID_BUSINESS_COST_CONTROL") {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML =
												". Έχετε ήδη  την προσφορά και θα αποδοθεί στον επόμενο τιμολογιακό του κύκλο";
										} else {
											document.getElementsByClassName(
												"customClassFailureReason",
											)[0].innerHTML =
												". Έχετε ήδη  την προσφορά και θα αποδοθεί στον επόμενο τιμολογιακό του κύκλο";
										}
									}
									document.getElementsByClassName(
										"processingMessage",
									)[0].style.display = "block";
									setTimeout(() => {
										document.getElementsByClassName(
											"loading",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassThankYouDiv",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassUnsuccessfulPrepaidServiceActivation",
										)[0].style.display = "block";
									}, 2000);
								}
								clearInterval(this.interval);
							} else if (data.item.status === "PROVISIONED_SUCCESS") {
								if (this.state.postActive) {
									document.getElementsByClassName(
										"processingMessage",
									)[0].style.display = "block";
									setTimeout(() => {
										document.getElementsByClassName(
											"loading",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassThankYouDiv",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassYouWillBeInformedBySMS",
										)[0].style.display = "block";
									}, 2000);
								} else {
									document.getElementsByClassName(
										"processingMessage",
									)[0].style.display = "block";
									setTimeout(() => {
										document.getElementsByClassName(
											"loading",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassThankYouDiv",
										)[0].style.display = "block";
										document.getElementsByClassName(
											"customClassSuccessfulActivation",
										)[0].style.display = "block";
									}, 2000);
								}
								clearInterval(this.interval);
							} else if (data.item.status === "ERROR") {
								if (!this.state.isPrepaidServiceActivation) {
									document.getElementsByClassName(
										"processingMessage",
									)[0].style.display = "block";
									setTimeout(() => {
										document.getElementsByClassName(
											"loading",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassThankYouDiv",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassUnsuccessfulActivation",
										)[0].style.display = "block";
									}, 2000);
								} else {
									document.getElementsByClassName(
										"processingMessage",
									)[0].style.display = "block";
									setTimeout(() => {
										document.getElementsByClassName(
											"loading",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassThankYouDiv",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassUnsuccessfulPrepaidServiceActivation",
										)[0].style.display = "block";
									}, 2000);
								}
								clearInterval(this.interval);
							} else {
								document.getElementsByClassName(
									"processingMessage",
								)[0].style.display = "block";
								if (this.state.hasChecksEnd) {
									setTimeout(() => {
										document.getElementsByClassName(
											"loading",
										)[0].style.display = "none";
										document.getElementsByClassName(
											"customClassYouWillBeInformedBySMS",
										)[0].style.display = "block";
									}, 2000);
									clearInterval(this.interval);
								}
							}
						}
					} else {
						if (data.item === "PROVISIONED_SUCCESS") {
							let modalData = null;
							try {
								const storedModalData = sessionStorage.getItem("modalData");
								if (storedModalData) {
									modalData = JSON.parse(storedModalData);
								}
							} catch (e) {
								modalData = null;
							}
							const processingMessage =
								document.getElementsByClassName("processingMessage")[0];
							if (processingMessage) {
								processingMessage.style.display = "block";
							}
							if (modalData && modalData.type === "VOLUME_CHARGE") {
								document.getElementsByClassName(
									"PassTitleToBeReplace",
								)[0].innerHTML = modalData.busServiceDes;
							}
							if (this.state.rogActivation) {
								document.getElementsByClassName(
									"userMessageHeader",
								)[0].innerHTML =
									"Ενεργοποιήθηκε <br/>η επιλογή της <br/>Χρέωση ανά ΜΒ.";
							} else if (this.state.postPass) {
								document.getElementsByClassName(
									"userMessageHeader",
								)[0].innerHTML = "Η αγορά του πακέτου <br/><br/>ολοκληρώθηκε.";
							}
							setTimeout(() => {
								document.getElementsByClassName("loading")[0].style.display =
									"none";
								document.getElementsByClassName("thank")[0].style.display =
									"block";
							}, 2000);
							clearInterval(this.interval);
						} else if (
							data.item === "PROVISIONED_FAILED" ||
							data.item === "ERROR"
						) {
							document.getElementsByClassName(
								"processingMessage",
							)[0].style.display = "block";
							setTimeout(() => {
								document.getElementsByClassName("loading")[0].style.display =
									"none";
								document.getElementsByClassName("thank")[0].style.display =
									"block";
								document.getElementsByClassName(
									"userMessageHeader",
								)[0].innerHTML =
									"Λυπούμαστε, <br/> το αίτημα σας δεν ολοκληρώθηκε.";
								document.getElementsByClassName(
									"thankMessageClass",
								)[0].innerHTML = " ";
							}, 2000);
							clearInterval(this.interval);
						} else {
							if (this.state.hasChecksEnd) {
								document.getElementsByClassName(
									"processingMessage",
								)[0].style.display = "block";
								setTimeout(() => {
									document.getElementsByClassName("loading")[0].style.display =
										"none";
									document.getElementsByClassName(
										"userMessageHeader",
									)[0].innerHTML =
										"Θα ενημερωθείτε για την εξέλιξη του αιτήματός σας με γραπτό μήνυμα";
									document.getElementsByClassName("thank")[0].style.display =
										"block";
								}, 2000);
								document.getElementsByClassName(
									"userMessageHeader",
								)[0].innerHTML =
									"Θα ενημερωθείτε για την εξέλιξη του αιτήματός σας με γραπτό μήνυμα";
								clearInterval(this.interval);
							}
							document.getElementsByClassName(
								"processingMessage",
							)[0].style.display = "block";
						}
					}
				})
				.catch(() => {
					clearInterval(this.interval);
				});
		}
		if (nextPolling === numberOfLoops) {
			this.setState({
				hasChecksEnd: true,
			});
		}
	};

	render() {
		let UserType = Functions["custom"]["getUserType"]();
		if (this.state.loaded) {
			if (
				UserType === "HYBRID_BUSINESS_COST_CONTROL" &&
				sessionStorage.getItem("pt") === "BLNC"
			) {
				return (
					<Fragment>
						<div className="header">
							<div className="hold">
								<a
									href="/"
									className="logo addCursorPointer"></a>
								<a
									href="/"
									className="refresh"></a>
							</div>
						</div>
						<div className="card-updates">
							<div className="payment-response">
								<div className="payment-title">Σας ευχαριστούμε πολύ.</div>
								<div className="payment-text">
									Επεξεργαζόμαστε το αίτημά σας. Θα ενημερωθείτε για την εξελιξη
									του αιτήματός σας με γραπτό μήνυμα.
								</div>
								<a
									href="/"
									className="payment-back">
									&lt; Επιστροφή
								</a>
							</div>
						</div>
					</Fragment>
				);
			}
			return (
				<Fragment>
					{this.state.data[0].header.component}
					<div className="thank-hold">
						{UserType === "POSTB" ||
						UserType === "POSTR" ||
						UserType === "POSTB_SPLIT" ? (
							<>
								<div className="loading">
									<h2 className="thankMessageClass">Σας ευχαριστούμε πολύ.</h2>
									<h3 className="processingMessage">
										Επεξεργαζόμαστε το αίτημά σας.
									</h3>
								</div>
								<div className="thank">
									<h2 className="thankMessageClass">Σας ευχαριστούμε πολύ.</h2>
									<h3 className="userMessageHeader">
										<span className="PassTitleToBeReplace"></span>
									</h3>
									<ThankYouCloseOrBackLink />
								</div>
							</>
						) : (
							<>
								<div className="loading">
									{UserType !== "HYBRID_BUSINESS_COST_CONTROL" ? (
										<h2 className="thankMessageClass">Σε ευχαριστούμε πολύ.</h2>
									) : (
										<h2 className="thankMessageClass">
											Σας ευχαριστούμε πολύ.
										</h2>
									)}
									<h3 className="processingMessage">
										Επεξεργαζόμαστε το αίτημά σας.
									</h3>
								</div>
								<div className="thank customDisplayNone customClassThankYouDiv customClassSuccessfulActivation">
									<h2 className="customClassThankYouheader">
										Σε ευχαριστούμε πολύ.
									</h2>
									<h3 className="customClassThankYouMessage">
										Η αγορά του πακέτου
										<br />
										{this.state.data[0].data.data.data
											.PREPAID_SERVICE_PROVISIONING_REQUEST
											? this.state.data[0].data.data.data
													.PREPAID_SERVICE_PROVISIONING_REQUEST.prepaidService
													.busServiceDes
											: null}
										<br />
										ολοκληρώθηκε.
									</h3>
									<ThankYouCloseOrBackLink />
								</div>
								<div className="thank customDisplayNone customClassThankYouDiv customClassYouWillBeInformedBySMS">
									<h2 className="customClassThankYouheader">
										Σε ευχαριστούμε πολύ.
									</h2>
									<h3 className="customClassThankYouMessage">
										Θα ενημερωθείτε για την εξέλιξη του αιτήματός σας με γραπτό
										μήνυμα
									</h3>
									<ThankYouCloseOrBackLink />
								</div>
								<div className="thank customDisplayNone customClassThankYouDiv customClassUnsuccessfulActivation">
									<h2 className="customClassThankYouheader">
										Σε ευχαριστούμε πολύ.
									</h2>
									<h3 className="customClassThankYouMessage">
										Λυπούμαστε, <br /> το αίτημα σου δεν ολοκληρώθηκε.
									</h3>
									<ThankYouCloseOrBackLink />
								</div>
								<div className="thank customDisplayNone customClassThankYouDiv customClassUnsuccessfulActivation customClassUnsuccessfulPrepaidServiceActivation">
									{UserType !== "HYBRID_BUSINESS_COST_CONTROL" ? (
										<Fragment>
											<h2 className="customClassThankYouheader">
												Σε ευχαριστούμε πολύ.
											</h2>
											<h3 className="customClassThankYouMessage">
												Λυπούμαστε, <br /> το αίτημα σου δεν ολοκληρώθηκε
												<span className="customClassFailureReason"></span>
											</h3>
										</Fragment>
									) : (
										<Fragment>
											<h2 className="customClassThankYouheader">
												Σας ευχαριστούμε πολύ.
											</h2>
											<h3 className="customClassThankYouMessage">
												Λυπούμαστε, <br /> το αίτημα σας δεν ολοκληρώθηκε
												<span className="customClassFailureReason"></span>
											</h3>
										</Fragment>
									)}

									<ThankYouCloseOrBackLink />
								</div>
							</>
						)}
					</div>
				</Fragment>
			);
		} else {
			if (
				UserType === "HYBRID_BUSINESS_COST_CONTROL" &&
				sessionStorage.getItem("pt") === "BLNC"
			) {
				return "";
			}
			if (this.props.data[0].data.data.status === 500) {
				return (
					<Fragment>
						{" "}
						<div className="header">
							<div className="hold">
								<a
									href="/"
									className="logo addCursorPointer"></a>
								<a
									href="/"
									className="refresh"></a>
							</div>
						</div>
						<div className="thank-hold errorPageDisplay">
							<div
								className="thank content"
								id="warningsErrorOccured"
								style={{ display: "block" }}>
								<h2 className="thankMessageClass">Σε ευχαριστούμε πολύ.</h2>
								<h3 className="userMessageHeader">
									<span className="PassTitleToBeReplace">
										Λυπούμαστε, <br /> το αίτημα σου δεν ολοκληρώθηκε.
									</span>
								</h3>
								<ThankYouCloseOrBackLink />
							</div>
						</div>
					</Fragment>
				);
			}
			return (
				<Fragment>
					<div className="header">
						<div className="hold">
							<a
								href="/"
								className="logo addCursorPointer"></a>
							<a
								href="/"
								className="refresh"></a>
						</div>
					</div>
					<div className="thank-hold">
						{UserType === "POSTB" ||
						UserType === "POSTR" ||
						UserType === "POSTB_SPLIT" ? (
							<>
								<div className="loading">
									<h2 className="thankMessageClass">Σας ευχαριστούμε πολύ.</h2>
								</div>
							</>
						) : (
							<>
								<div className="loading">
									{UserType !== "HYBRID_BUSINESS_COST_CONTROL" ? (
										<h2 className="thankMessageClass">Σε ευχαριστούμε πολύ.</h2>
									) : (
										<h2 className="thankMessageClass">
											Σας ευχαριστούμε πολύ.
										</h2>
									)}
									<h3 className="processingMessage">
										Επεξεργαζόμαστε το αίτημά σας.
									</h3>
								</div>
							</>
						)}
					</div>
				</Fragment>
			);
		}
	}
}

export default ThankYou;
